export default __webpack_public_path__ + "static/media/garagebanner.ab199984.jpg";